var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "cart-bar", style: _vm.barStyle }, [
        _c("div", { staticClass: "cart-icon" }, [
          _vm.configObj.cartIcon.url
            ? _c("img", { attrs: { src: _vm.configObj.cartIcon.url, alt: "" } })
            : _c("i", { staticClass: "el-icon-shopping-cart-full" }),
          _c("span", { staticClass: "badge" }, [_vm._v("1")]),
        ]),
        _c("div", { staticClass: "cart-price" }, [
          _c("div", { staticClass: "total", style: _vm.priceStyle }, [
            _c("span", { staticClass: "symbol" }, [_vm._v("¥")]),
            _vm._v("24.9"),
          ]),
          _vm.configObj.discountShow.val
            ? _c("div", { staticClass: "discount", style: _vm.discountStyle }, [
                _vm._v("已优惠 ¥4.0"),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "settle-btn", style: _vm.btnStyle }, [
          _vm._v(_vm._s(_vm.configObj.btnConfig.val || "去结算")),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }